import { ManagedReceivingGlobalApiV2 as ApiV2 } from "@capstone/mock-api";
import { OrganizationType } from "src/app/core/user-registration.model";

export class RegistrationQueryModel {
  public constructor(args: ClassProperties<RegistrationQueryModel>) {
    this.city = args.city;
    this.comments = args.comments;
    this.country = args.country;
    this.jobTitle = args.jobTitle;
    this.mcOrDotNumber = args.mcOrDotNumber;
    this.organizationName = args.organizationName;
    this.organizationType = args.organizationType;
    this.postalCode = args.postalCode;
    this.state = args.state;
    this.streetAddress = args.streetAddress;
    this.workPhoneNumber = args.workPhoneNumber;
  }

  public readonly city: string;
  public readonly comments: string;
  public readonly country: string;
  public readonly jobTitle: string;
  public readonly mcOrDotNumber: string;
  public readonly organizationName: string;
  public readonly organizationType: OrganizationType;
  public readonly postalCode: string;
  public readonly state: string;
  public readonly streetAddress: string;
  public readonly workPhoneNumber: string;

  public serialize(): ApiV2.CreateOrganizationInfoCommand {
    return {
      city: this.city,
      comments: this.comments,
      country: this.country,
      jobTitle: this.jobTitle,
      mcDotNumber: this.mcOrDotNumber,
      name: this.organizationName,
      organizationTypeId: this.organizationType.id,
      postalCode: this.postalCode,
      state: this.state,
      streetAddress: this.streetAddress,
      workPhone: this.workPhoneNumber,
    };
  }
}
